module.exports = __webpack_public_path__ + "assets/img/6080ef6982682dc64576de15e350e17b.png";